import { getAccOrigin, setEnv, setRegion } from '@adsk/acs-sc-web-platform-api';
import { getExoSkeletonRuntime, setIsInExoSkeleton } from '../internal';
import { report, REPORT_TYPES } from '../monitoring';
import { isInExoSkeleton } from '../runtime';
import { fetchRemotes } from './fetch';
import { EXO_SKELETON_EVENT_NAMES } from '../consts';
export function getRemoteRuntime(scope) {
  var _runtime$remotes;
  const runtime = getExoSkeletonRuntime();
  return runtime === null || runtime === void 0 ? void 0 : (_runtime$remotes = runtime.remotes) === null || _runtime$remotes === void 0 ? void 0 : _runtime$remotes[scope];
}
export function setExoSkeletonRemotes(remotes) {
  const runtime = getExoSkeletonRuntime();
  runtime.remotes = remotes;
}
async function createRuntimeRemotes(_ref) {
  let {
    getRemoteOverride,
    transformRemotesUrl
  } = _ref;
  const remotes = await fetchRemotes({
    transformRemotesUrl
  });
  const runtimeRemotes = {};
  for (const {
    scope,
    url,
    moniker
  } of remotes) {
    const overrides = (await (getRemoteOverride === null || getRemoteOverride === void 0 ? void 0 : getRemoteOverride(scope))) || {};
    const hasOverride = Object.keys(overrides).length > 0;
    const resolvedMoniker = overrides.moniker || moniker;
    const resolvedUrl = new URL(overrides.url || url, getAccOrigin());
    runtimeRemotes[scope] = {
      override: hasOverride,
      moniker: resolvedMoniker,
      url: resolvedUrl.href,
      scope,
      /**
       * @deprecated kept for backwards compatibility
       */
      get: async () => {
        return {
          scope,
          url: resolvedUrl.href
        };
      }
    };
  }
  return runtimeRemotes;
}
function setEnvAndRegion(_ref2) {
  let {
    env,
    region
  } = _ref2;
  if (env) {
    setEnv(env);
    report({
      type: REPORT_TYPES.info,
      value: 'EXO_SKELETON_ENVIRONMENT_CONFIG_SET_ENV',
      scope: 'ACCExoSkeleton',
      context: {
        env
      }
    });
  }
  if (region) {
    setRegion(region);
    report({
      type: REPORT_TYPES.info,
      value: 'EXO_SKELETON_ENVIRONMENT_CONFIG_SET_REGION',
      scope: 'ACCExoSkeleton',
      context: {
        region
      }
    });
  }
}
export async function initializeExoSkeletonRuntimeValues() {
  let {
    getRemoteOverride,
    environmentConfig: {
      env,
      region
    } = {},
    transformRemotesUrl
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (isInExoSkeleton()) {
    return;
  }
  setEnvAndRegion({
    env,
    region
  });
  setExoSkeletonRemotes(await createRuntimeRemotes({
    transformRemotesUrl,
    getRemoteOverride
  }));
  setIsInExoSkeleton();
  globalThis.dispatchEvent(new Event(EXO_SKELETON_EVENT_NAMES.REMOTES_LIST_FETCHED));
}
//# sourceMappingURL=runtime.js.map